import useNavigationStore from '@src/stores/navigationStore';
import useRegistrationStore from '@src/stores/registrationStore';

import BlockTitle from '@src/components/_shared/UI/BlockTitle';
import BackButton from '@src/components/_shared/BackButton';
import Container from '@src/components/_shared/Container';
import Subtitle from '@src/components/_shared/UI/Subtitle';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getReferencialData } from '@src/api/Referencial';
import DropdownList from '@src/components/_shared/UI/DropdownList';
import Loader from '@src/components/_shared/UI/Loader';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import { companyUpdate } from '@src/api/Registration';
import { handleApiError } from '@src/utilities/functions';

export default function LCBFT() {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();

    const { data, isLoading } = useQuery({ 
        queryKey: [`legalCapacities`],
        queryFn: () => getReferencialData({type: 'company/industry-sectors'})
    });

    const { basic, industry_sector } = registration.company;
    const { mutate, isPending } = useMutation({
        mutationFn: () => companyUpdate({ value: { basic, industry_sector }, is_psi: registration.partner_informations.is_partner, person_id: registration.person_id }),
        onSuccess: () => {
            setBlock('LatestResults')
        },
        onError: (error: any) => handleApiError(error)
    });

    const _onGoBack = () => {
        setSection(3)
        setBlock('Beneficiaries')
    };

    const handlSelectIndustrySector = (value: string) => {
        setField('company.industry_sector', value)
    }

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Information relative à la lutte contre le blanchiment de capitaux et le financement du terrorisme (conformément au titre V du code Monétaire et Financier)" />
            <Subtitle content="Quel est le secteur d’activité de la société ?" />
            {isLoading ?
                <Loader type='SPINNER' />
                :
                <div style={{width: '100%'}}>
                    <DropdownList
                        title="Secteur d’activité"
                        width="100%"
                        options={data}
                        selected={registration.company.industry_sector}
                        onSelect={handlSelectIndustrySector}
                    />
                    <ValidateButton title="Valider" onClick={mutate} disabled={!registration.company.industry_sector || isPending} onLoading={isPending} />
                </div>
            }
        </Container>
    );
}
